import React from 'react';
import { Path } from 'app/const/Path';
import { HashLink } from 'react-router-hash-link';
import { Container, Grid } from '@material-ui/core';
import { FilledButton } from 'app/components/Buttons/FilledButton';
import { sneakPeekCss } from 'app/modules/web-shop/sub-modules/landing-module/components/sneak-peak-block/style';

export default function SneakPeekBlock() {
  return (
    <div
      css={`
        background: #f7f7f7;
      `}
    >
      <Container maxWidth="lg" css={sneakPeekCss}>
        <Grid
          container
          spacing={8}
          css={`
            align-items: center;
            justify-content: space-between;
          `}
        >
          <Grid item xs={12} md={5} lg={7}>
            <iframe
              width="100%"
              height="486"
              allowFullScreen
              frameBorder={0}
              style={{ borderRadius: '30px' }}
              src="https://www.youtube.com/embed/zLzPnCarLj8"
              title="Unlock the full power of data with the AIDA Platform - Perks of acquiring your AIDA licence"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            />
          </Grid>
          <Grid item xs={12} md={7} lg={5}>
            <h2>Why AIDA?</h2>
            <p>
              Discover effortless <b>IATI data management</b> <br /> on AIDA.
              Make use of unlimited publications <br /> directly to the IATI
              registry, a built-in IATI <br /> validator, and an intuitive
              visualisation platform.
            </p>
            <div
              css={`
                margin-top: 3.5rem;
                width: 60%;
              `}
            >
              <HashLink to={`${Path.webshop.support}#contact`}>
                <FilledButton label="Contact Us" />
              </HashLink>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
